/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default $ => css`
  .user-nav-dropdown {
    .user-info {
      .role {
        font-size: small;
      }
    }
  }
`;
